import React from "react"
import styled from "styled-components"
import colors from "@constants/colors"
import breakpoints from "@constants/breakpoints"
import {
  h5Styles,
  smallcapsBold14Styles,
  smallcapsRegular13Styles,
  body28Styles,
  paragraph20Styles,
} from "@constants/typography"
import BackgroundImageHelper, {
  Container as BackgroundImageHelperContainer,
} from "@components/BackgroundImageHelper"
import Slider from "@components/Slider"

const Container = styled.div`
  ${BackgroundImageHelperContainer} {
    flex-shrink: 0;
    align-self: stretch;
    justify-self: stretch;
    display: flex;
    width: 85vw;
    height: auto;
    min-height: calc(85vw * 1.3);
    margin-right: 8px;
    padding: 42px 24px;

    @media ${breakpoints.tablet} {
      width: calc((8 / 9 + 10) / 12 * 100vw);
      min-height: calc((8 / 9 + 10) / 12 * 100vw * 0.7);
      margin-right: 16px;
      padding: calc(1 / 12 * 100vw) calc(3 / 12 * 100vw) calc(1 / 12 * 100vw)
        calc(1.5 / 12 * 100vw);
    }

    @media ${breakpoints.laptop} {
      width: calc(10.5 / 12 * 100vw);
      min-height: calc(10.5 / 12 * 100vw * 0.5);
      margin-right: 0;
      padding: calc(1 / 12 * 100vw) calc(3 / 12 * 100vw) calc(1 / 12 * 100vw)
        calc(1.5 / 12 * 100vw);
    }
  }
`

const ContentWrapper = styled.div`
  flex-direction: column;
  justify-content: space-between;
  display: flex;
  height: 100%;
`

const Content = styled.div`
  white-space: initial;
`

const Question = styled.div`
  ${smallcapsBold14Styles}
  opacity: 0.6;
  margin-bottom: 38px;
  letter-spacing: 0.9px;
  color: ${colors.offWhite};

  @media ${breakpoints.tablet} {
    ${h5Styles}
    margin-bottom: 54px;
    color: ${colors.offWhite};
  }

  @media ${breakpoints.laptop} {
    ${h5Styles}
    margin-bottom: 54px;
    color: ${colors.offWhite};
  }
`

export const Answer = styled.div`
  ${paragraph20Styles}
  color: ${colors.offWhite};

  @media ${breakpoints.tablet} {
    ${body28Styles}
    color: ${colors.offWhite};
  }

  @media ${breakpoints.laptop} {
    ${body28Styles}
    color: ${colors.offWhite};
  }
`

const Count = styled.div`
  ${smallcapsRegular13Styles}
  opacity: 0.6;
  margin-top: 38px;
  color: ${colors.offWhite};

  @media ${breakpoints.tablet} {
    ${smallcapsBold14Styles}
    margin-top: 54px;
    color: ${colors.offWhite};
  }

  @media ${breakpoints.laptop} {
    ${smallcapsBold14Styles}
    color: ${colors.offWhite};
  }
`

export interface TextBlockProps {
  header: string
  body?: string
  backgroundImage: string
}

interface TextSliderProps {
  blockId?: string
  textBlocks: Array<TextBlockProps>
  maxCount: number
}

const getCount = (i: number): string => {
  if (i < 10) {
    return `0${i}`
  } else {
    return i.toString()
  }
}

const TextSlider: React.FC<TextSliderProps> = ({
  blockId,
  textBlocks,
  maxCount,
}) => {
  return (
    <Slider blockId={blockId} slideCount={maxCount} dynamicHeight>
      {textBlocks.map((block, i) => {
        return (
          <Container key={`${i}-${block.header}`}>
            <BackgroundImageHelper src={block.backgroundImage}>
              <ContentWrapper>
                <Content>
                  <Question>{block.header}</Question>
                  {block.body && <Answer>{block.body}</Answer>}
                </Content>
                <Count>{`${getCount(i + 1)} / ${getCount(maxCount)}`}</Count>
              </ContentWrapper>
            </BackgroundImageHelper>
          </Container>
        )
      })}
    </Slider>
  )
}

export default TextSlider
